import { useAppSelector } from "redux/hooks";
import UpdatePaymentLinkForm from "./UpdatePaymentLinkForm";
import PaymentLinkService from "services/paymentLink.service";

export default function UpdatePaymentLink() {
  const modalData = useAppSelector((state) => state.modal.data);
  const handleSubmit = async (values: any) => {
    const data = { ...values };
    if (data?.trip_ids) {
      data.trip_ids = data?.trip_ids.map((trip: any) => trip.value);
    }
    delete data.my_email;
    await PaymentLinkService.updatePaymentLink(
      modalData?.PayentLinkId,
      data,
    );
  };
  return (
    <div>
      <h3>Update Payment Link</h3>
      <UpdatePaymentLinkForm onSubmit={handleSubmit} />
    </div>
  );
}
